'use strict'
import { request } from '../../plugins/http'
import { resetLibTranslate } from './translate.ctrl'

export default async (factoryId) => {
    await request.get('/traducao', {params:{factoryId}}).then((response) => {
        localStorage.setItem('libTranslate', JSON.stringify(response.data))
        resetLibTranslate()
    })
}